import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { Modal } from '@/components';
import { Column, Row } from '@/components/SettingsLayout';
import { Button, Text } from '@/ui';
import { useDeleteApiKeyMutation } from '@/store/slices/orgApiKeySlice';

function DeleteApiKeyModal() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { id: organizationId } = useParams();
  const [searchParams] = useSearchParams();
  const open = searchParams.get('mode') === 'delete-api-key';
  const keyId = searchParams.get('keyId');

  const [deleteApiKey, { isLoading }] = useDeleteApiKeyMutation();

  const closeModal = () => {
    navigate(pathname);
  };

  const handleDelete = async () => {
    if (!organizationId || !keyId) return;

    try {
      await deleteApiKey({
        organizationId,
        apiKeyId: keyId,
      }).unwrap();
      toast.success(t('ApiKeys.delete_success'));
      closeModal();
    } catch (error) {
      console.error('Failed to delete API key', error);
      toast.error(t('ApiKeys.delete_error'));
    }
  };

  return (
    <Modal open={open && !!keyId} closeModal={closeModal} fitContent>
      <div className='w-[450px]'>
        <Modal.Title title={t('ApiKeys.delete_title')} />
        <Modal.Content border>
          <Column gapSize='12'>
            <Text size='s'>{t('ApiKeys.delete_confirm')}</Text>
            <Text size='xs' color='base-grey'>
              {t('ApiKeys.delete_warning')}
            </Text>
          </Column>
        </Modal.Content>
        <Modal.Footer justify='flex-end'>
          <Row gapSize='8' fullWidth={false}>
            <Button
              variant='outline'
              onClick={closeModal}
              type='button'
              disabled={isLoading}
              testId='cancel-delete-api-key'
            >
              {t('Shared.cancel')}
            </Button>
            <Button
              variant='danger'
              onClick={handleDelete}
              disabled={isLoading}
              testId='confirm-delete-api-key'
            >
              {t('ApiKeys.delete')}
            </Button>
          </Row>
        </Modal.Footer>
      </div>
    </Modal>
  );
}

export default DeleteApiKeyModal;
